import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import CTStepper from 'components/CTStepper';
import { formatAppointment, formatAppointmentByObject } from 'utils/formatter.js';

const ORDER_HISTORY = [
  { id: 'message', sortable: true, label: 'Message', show: true },
  { id: 'user', sortable: true, label: 'User', show: true },
  { id: 'timestamp', sortable: true, label: 'TimeStamp', show: true },
];

const OrderStats = ({ open,
  orderStats,
  orderHistory,
  title,
  fnOnCloseDialogHandler,
  ...rest }) => {
  return (
    title === 'Order Stats' ?
      renderOrderStatsStepper(orderStats) :
      <Card
        {...rest}>
        <PerfectScrollbar>
          {renderOrderNotification(orderHistory)}
        </PerfectScrollbar>
      </Card>
  );
};

const renderOrderStatsStepper = (orderStats) => {
  const orderLegs = orderStats.map(e => e.legId);
  const uniqueLegs = orderLegs.filter((v,i,a) => a.indexOf(v) === i);
  return uniqueLegs.map(legId => (
    <Box component='paper' elevation={1} key={`key:${legId}`} sx={{mb: 1}}>
      <Typography align='center' color='textPrimary' variant='subtitle2'>{`LegId: ${legId}`}</Typography>
      <CTStepper stages={orderStats} />
    </Box>
  ));
};

const renderOrderNotification = (orderHistory) => {
  return (
    <Table size='small'>
      <TableHead>
        <TableRow>
          {ORDER_HISTORY.map(header => (
            <TableCell key={header.id}>
              {header.label}
            </TableCell>
          ))
          }
        </TableRow>
      </TableHead>
      <TableBody>
        {orderHistory.map((data, idx) => (
          <TableRow
            hover
            key={idx}
          >
            <TableCell>
              {data.message}
            </TableCell>
            <TableCell>
              {data.username}
            </TableCell>
            <TableCell>
              {formatAppointment(data.timestamp)}
            </TableCell>
          </TableRow>
        )
        )}
      </TableBody>
    </Table>
  );
};

export default OrderStats;